import React from 'react';
import PropTypes from 'prop-types';
import '../../product/css/badge.less';

const Badge = ({ status, text }) => (
    <div className={`product-badge ${status}`}>
        { text }
    </div>
);

Badge.propTypes = {
    /*string that represents the color of the badge*/
    status: PropTypes.oneOf(['primary','warn','alert','disabled']).isRequired,
    /*text that displays in the badge*/
    text: PropTypes.string.isRequired
};
export default Badge;
